import { c as _c } from "react/compiler-runtime";
import { ListStatusIcon } from "@components/common/faro-table/bulk-dialog/content-list/list-status-icon";
import { MemberListContent } from "@components/common/faro-table/bulk-dialog/content-list/member-list-content";
import { ProjectListContent } from "@components/common/faro-table/bulk-dialog/content-list/project-list-content";
import { TeamListContent } from "@components/common/faro-table/bulk-dialog/content-list/team-list-content";
import { SnapshotListContent } from "@components/common/faro-table/bulk-dialog/content-list/snapshot-list-content";
import { ListItem, NO_TRANSLATE_CLASS, red } from "@flat-ui";
import { withEllipsisTwoLines } from "@styles/common-styles";
/** List item in bulk action dialog  */
export function BulkActionListItem(t0) {
  const $ = _c(17);
  const {
    tableDataType,
    item
  } = t0;
  let content = null;
  bb0: switch (tableDataType) {
    case "projects":
      {
        let t1;
        if ($[0] !== item) {
          t1 = ProjectListContent({
            item
          });
          $[0] = item;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        content = t1;
        break bb0;
      }
    case "members":
      {
        let t1;
        if ($[2] !== item) {
          t1 = MemberListContent({
            item
          });
          $[2] = item;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        content = t1;
        break bb0;
      }
    case "teams":
      {
        let t1;
        if ($[4] !== item) {
          t1 = TeamListContent({
            item
          });
          $[4] = item;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        content = t1;
        break bb0;
      }
    case "snapshots":
      {
        let t1;
        if ($[6] !== item) {
          t1 = SnapshotListContent({
            item
          });
          $[6] = item;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        content = t1;
        break bb0;
      }
    default:
  }
  if (!content) {
    return null;
  }
  const t1 = item.status === "not-allowed" ? red[100] : "none";
  let t2;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      ml: "12px",
      ...withEllipsisTwoLines,
      maxWidth: "350px"
    };
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1) {
    t3 = {
      px: "0px",
      fontSize: "14px",
      backgroundColor: t1,
      "& .MuiListItemText-root": t2
    };
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== item) {
    t4 = <ListStatusIcon item={item} />;
    $[11] = item;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== content || $[14] !== t3 || $[15] !== t4) {
    t5 = <ListItem sx={t3} className={NO_TRANSLATE_CLASS} secondaryAction={t4}>{content}</ListItem>;
    $[13] = content;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}